// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box, Button, Popover } from '@mui/material';

// ui
import { Legend, LegendItemProps } from '../Legend/Legend';

// icons
import { ListAltOutlined as IconListAlt } from '@mui/icons-material';

// props
export interface BtnLegendProps {
	items?: LegendItemProps[];
}

export const BtnLegend = ({ items = [] }: BtnLegendProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleToggleLegend = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	return (
		<>
			<Button
				fullWidth={true}
				onClick={handleToggleLegend}
				startIcon={<IconListAlt />}
				variant="outlined">
				{t('legend')}
			</Button>
			<Popover anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				<Box sx={{ maxWidth: 240, maxHeight: 240, overflowY: 'auto' }}>
					<Legend items={items} />
				</Box>
			</Popover>
		</>
	);
};
